import request from '../../../shared/request'

export function getScheduleSiteWorkDates(job_id) {
  return request(`/job/schedules/${job_id}/site_work`)
}

export function addScheduleSiteWorkDates(payload) {
  return request(`/job/schedules/${payload.job_id}/site_work`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteScheduleSiteWork(payload) {
  return request(`/job/schedules/${payload.schedule_id}/site_work`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleSiteWorkDates(payload) {
  return request(`/job/schedules/${payload.job_id}/site_work`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleSiteWorkNotes(payload) {
  return request(`/job/schedules/${payload.job_id}/site_work/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/scheduleSiteWork.js